export default __webpack_public_path__ + "static/media/verlinde.b237cff4.svg";